import StringUtils from '../text/StringUtils';
String.prototype.append = function (value, delimiter = '') {
    return StringUtils.append(this, value, delimiter);
};
String.prototype.appendAffix = function (prefix, value, suffix, delimiter = ' ') {
    return StringUtils.appendAffix(this, prefix, value, suffix, delimiter);
};
String.prototype.appendIf = function (condition, value, delimiter = '') {
    return StringUtils.appendIf(this, condition, value, delimiter);
};
String.prototype.between = function (startDelimiter, endDelimiter) {
    return StringUtils.between(this, startDelimiter, endDelimiter);
};
String.prototype.changeCase = function (textCase) {
    return StringUtils.changeCase(this, textCase);
};
String.prototype.chars = function () {
    return StringUtils.chars(this);
};
String.prototype.contains = function (value, caseSensitive = true) {
    return StringUtils.contains(this, value, caseSensitive);
};
String.prototype.containsAny = function (values, caseSensitive = true) {
    return StringUtils.containsAny(this, values, caseSensitive);
};
String.prototype.endsWithEx = function (suffix, caseSensitive = true) {
    return StringUtils.endsWith(this, suffix, caseSensitive);
};
String.prototype.endsWithAny = function (suffixes, caseSensitive = true) {
    return StringUtils.endsWithAny(this, suffixes, caseSensitive);
};
String.prototype.forEachMatch = function (pattern, matchCallback, nonMatchCallback, options) {
    return StringUtils.forEachMatch(this, pattern, matchCallback, nonMatchCallback, options);
};
String.prototype.hasMatch = function (pattern, options) {
    return StringUtils.hasMatch(this, pattern, options);
};
String.prototype.indexOfEx = function (value, startIndex = 0, caseSensitive = true) {
    return StringUtils.indexOf(this, value, startIndex, caseSensitive);
};
String.prototype.indexOfAny = function (values, startIndex = 0, caseSensitive = true) {
    return StringUtils.indexOfAny(this, values, startIndex, caseSensitive);
};
String.prototype.isHex = function () {
    return StringUtils.isHex(this);
};
String.prototype.isNumeric = function () {
    return StringUtils.isNumeric(this);
};
String.prototype.lastIndexOfEx = function (value, startIndex = 0, caseSensitive = true) {
    return StringUtils.lastIndexOf(this, value, startIndex, caseSensitive);
};
String.prototype.lastIndexOfAny = function (values, startIndex = 0, caseSensitive = true) {
    return StringUtils.lastIndexOfAny(this, values, startIndex, caseSensitive);
};
String.prototype.matchAllEx = function (pattern, options) {
    return StringUtils.matchAll(this, pattern, options);
};
String.prototype.matchFirst = function (pattern, options) {
    return StringUtils.matchFirst(this, pattern, options);
};
String.prototype.matchAndReplaceAll = function (pattern, replaceValue, options) {
    return StringUtils.matchAndReplaceAll(this, pattern, replaceValue, options);
};
String.prototype.padLeft = function (width, value = '0') {
    return StringUtils.padLeft(this, width, value);
};
String.prototype.padRight = function (width, value = '0') {
    return StringUtils.padLeft(this, width, value);
};
String.prototype.removeAll = function (value, caseSensitive) {
    return StringUtils.removeAll(this, value, caseSensitive);
};
String.prototype.removeAllMatches = function (pattern, options) {
    return StringUtils.removeAllMatches(this, pattern, options);
};
String.prototype.removeAt = function (index, length) {
    return StringUtils.removeAt(this, index, length);
};
String.prototype.removeBetween = function (startDelimiter, endDelimiter, removeDelimiters = false) {
    return StringUtils.removeBetween(this, startDelimiter, endDelimiter, removeDelimiters);
};
String.prototype.removeLeft = function (width) {
    return StringUtils.removeLeft(this, width);
};
String.prototype.removeNonNumerics = function (options) {
    return StringUtils.removeNonNumerics(this, options);
};
String.prototype.removeNonAlphabetics = function () {
    return StringUtils.removeNonAlphabetics(this);
};
String.prototype.removeNonAlphanumerics = function () {
    return StringUtils.removeNonAlphanumerics(this);
};
String.prototype.removeRange = function (startIndex, endIndexExclusive) {
    return StringUtils.removeRange(this, startIndex, endIndexExclusive);
};
String.prototype.replaceAll = function (searchValue, replaceValue) {
    return StringUtils.replaceAll(this, searchValue, replaceValue);
};
String.prototype.reverse = function () {
    return StringUtils.reverse(this);
};
String.prototype.splitEx = function (delimiter, options) {
    return StringUtils.split(this, delimiter, options);
};
String.prototype.splitLines = function (options) {
    return StringUtils.splitLines(this, options);
};
String.prototype.startsWithAny = function (prefixes, caseSensitive) {
    return StringUtils.startsWithAny(this, prefixes, caseSensitive);
};
String.prototype.startsWithEx = function (prefix, caseSensitive) {
    return StringUtils.startsWith(this, prefix, caseSensitive);
};
String.prototype.trimLeftEx = function (characters) {
    return StringUtils.trimLeft(this, characters);
};
String.prototype.trimRightEx = function (characters) {
    return StringUtils.trimRight(this, characters);
};
String.prototype.trimEx = function (characters) {
    return StringUtils.trim(this, characters);
};
String.prototype.trimWithEllipsis = function (maxLength) {
    return StringUtils.trimWithEllipsis(this, maxLength);
};
String.compare = StringUtils.compare;
String.emptyIfNull = StringUtils.emptyIfNull;
String.equal = StringUtils.equal;
String.isNullOrEmpty = StringUtils.isNullOrEmpty;
String.isNullOrWhiteSpace = StringUtils.isNullOrWhiteSpace;
String.isString = StringUtils.isString;
//# sourceMappingURL=StringExtensions.js.map